import React from "react";
import {Row} from "react-bootstrap";
import {Col} from "react-bootstrap";
import useQueryHiresByJobId from "./useQueryHiresByJobId.js";
import WaitForData from "../../common/data-fetching/WaitForData.js";
import WithRedirectionUserIsAuthorized from "../../authentication-ui/WithRedirectionUserIsAuthorized.js";
import ApplicationItem from "./ApplicationItem.js";
import useTranslationJobDashboard from "../useTranslationJobDashboard.js";
import useShowLoader from "../../common/loading-widgets/useShowLoader.js";
import PageSubtitle from "../../common/widgets/PageSubtitle.js";
import "./HiredCandidatesBlock.scss";

export default function HiredCandidatesBlock(props) {
  const { t, loading: tLoading } = useTranslationJobDashboard();
  useShowLoader(tLoading, "HiredCandidatesBlock");

  const { jobId } = props;
  const {
    data: hires,
    loading: hiresLoading,
    errors: hireErrors,
  } = useQueryHiresByJobId(jobId);

  return (
    <WithRedirectionUserIsAuthorized
      yes={() => (
        <WaitForData
          loading={hiresLoading}
          errors={hireErrors}
          onLoaded={() => (
            <>
              {hires.length > 0 && (
                <div className="HiredCandidatesBlock">
                  <Row>
                    <Col className={"title-col"}>
                      <PageSubtitle
                        colTitle={t(
                          "job-dashboard:job_dashboard_hired_candidates_title"
                        )}
                      />
                    </Col>
                  </Row>
                  <Row>
                    <Col>
                      {hires.map((item) => (
                        <div key={item.applicationId}>
                          <ApplicationItem applicationId={item.applicationId} />
                          <hr />
                        </div>
                      ))}
                    </Col>
                  </Row>
                </div>
              )}
            </>
          )}
        />
      )}
    />
  );
}
